import React, { useEffect, useState } from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import PriceSummarySection from '../Constans/PriceSummarySection/PriceSummarySection';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import Checkbox from 'app/Components/Shared/CheckBox/Checkbox';
import { GetCreditCardTypeId, formatActivityHours, isNoDeliveryProccess, steps } from '../IdfSaleEnums';
import usePageCapture from '../../../../utilities/hooks/usePageCapture';
import useSaveToCalender from '../../../../utilities/hooks/useSaveToCalender';
import BtnWhiteBlackBorderSmallSize from '../../../Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import Buttons from '../Constans/Buttons';
import BtnPink from '../../../Shared/Buttons/BtnPink';
import PickUpCenterInformation from './PickUpCenterInformation';
import ErrorPage from '../PopUps/ErrorPage';
import SuccessEsim from './SuccessEsim';
import { getTextByType, EsimTextFieldName } from '../idfEsimTextHelper';
import { getTimeFromDateTime } from '../../../../utilities/dateUtils';
import EpiContext from "@episerver/spa-core/Spa";
import Config from 'app/Config'
import OrderSummarySucceededButton from './OrderSummarySucceededButton';
import { dwhReport, dwhDictionary } from '../dwhReports/dwhGeneralReport';
const OrderSummary = (props) => {
  const [mailAddress, setMailAddress] = useState(props.customerEmail);
  const [mailError, setMailError] = useState(null);
  const [checkBoxChecked, setCheckBoxChecked] = useState(false);
  const { idfStore: store } = props;
  const { paymentCg: payment } = props;
  const { auth } = props;
  const [isSubmitSuccess, setIsSubmitSuccess] = useState(null);
  const { selectedPhoneNumber, selectedPackage } = store;
  const { captureRef, capturePage } = usePageCapture();
  const isShowEsim = props.contentData.eSimFlag.value;
  const [confirmMail, setConfirmMail] = useState('');

  const isEsim = store.simType === 'eSIM';

  const esimTitle = getTextByType(EsimTextFieldName.Title);
  const esimText = getTextByType(EsimTextFieldName.OrderSummary);


  const isEsimAndLineType = isEsim
    ? (store.lineType == 3 && { value: true, type: 'NEW_LINE' }) || (store.lineType == 1 && { value: true, type: 'NIUD' })
    : false;
  useEffect(() => {
    store.isSaleDone && props.setIsShowHeader(false);
  }, []);


  const convertPackageTitle = (packageTitle) => {
    const tempElement = document.createElement('div');

    tempElement.innerHTML = packageTitle;
    const textContent = tempElement.textContent || tempElement.innerText;
    return textContent;
  };

  const onSubmit = async () => {
    const res = await props.onFinalSubmit();
    if (res.payload.isSuccess) {
      //props.saveToHistory();
      window.scrollTo(0, 0);
      setIsSubmitSuccess(true);
    } else {
      setIsSubmitSuccess(false);
    }
  };
  const totalPrice = store?.selectedPhone?.totalPrice;
  const productsArr = [
    {
      name: isEsim ? 'eSIM' : 'Sim',
      price: 0,
      monthly: false,
    },
  ];
  store.processType === 'DEVICE' &&
    productsArr.push({
      name: store.selectedPhone.groupName + 'GB',
      price: parseFloat(totalPrice).toFixed(2),
      monthlyPrice: parseFloat((totalPrice / parseInt(store.selectedPhone.selectedPayment, 10)).toFixed(2)),
      payments: parseInt(store.selectedPhone.selectedPayment, 10),
      monthly: true,
    });
  const { user_type_id: userType } = props.idfStore.userDetails;

  const warrantyPriceToInt = userType === 'Regular' ? Math.round(parseFloat(props.contentData.warrantyPrice.value) * 100) / 100 : 0;

  const packagePrice = store.selectedPackage.price

  const monthlyProductsArr = [
    {
      title: 'תכנית סלולר',
      name: convertPackageTitle(store.selectedPackage.title),
      price: packagePrice > 0 ? packagePrice : 0,
      monthly: false,
    },
  ];
  store.selectedPhone?.insuranceOption === 'ADD_INSURANCE' &&
    monthlyProductsArr.push({
      name: 'שירות תיקונים בסיסי',
      price: warrantyPriceToInt,
      monthly: false,
    });


  const paymentInfo = {
    cardType: payment?.CCType,
    last4Digits: payment?.Credit4Digits,
    expirationDate: `${payment?.CGData?.cardMonth}/${payment?.CGData?.cardYear}`,
    id: payment?.CGData?.id,
  };

  const deliveryAddressInfo = store.deliverySelectedAddress;
  const deliveryDate = new Date(store.selectedDeliverySlot.deliveryStartTime).toLocaleDateString('en-GB');
  const deliveryInfo = store.deliveryMode === 'DELIVERY' && {
    deliveryHebrewDayOfTheWeek: store.selectedDeliverySlot.hebrewDayName,
    deliveryDate: deliveryDate,
    deliveryRange: [
      getTimeFromDateTime(store.selectedDeliverySlot.deliveryStartTime),
      getTimeFromDateTime(store.selectedDeliverySlot.deliveryEndTime),
    ],
    address: `${deliveryAddressInfo.streetName + ' ' + deliveryAddressInfo.home} ,${deliveryAddressInfo.entry !== ' ' ? deliveryAddressInfo.entry + ',' : ''
      } דירה ${deliveryAddressInfo.apartment},  ${deliveryAddressInfo.cityName}`,
    recipientName: store.deliverySelectedFirstName + ' ' + store.deliverySelectedLastName,
    recipientPhoneNumber: store.deliverySelectedPhoneNumber,
  };
  const handleAddToCalenderClick = () => {
    const calendarSettings = {
      deliverySlots: store.selectedDeliverySlot,
    };
    useSaveToCalender(calendarSettings);
  };

  function getCustomerNewNumber() {
    let customerNewNumber;
    if (store.lineType == 1) return '0' + store.userDetails.new_line_code;
    if (store.lineType != 1) return store.lineNumber;
  }

  function PriceInformation(props) {
    return (
      <div className='price-information-container'>
        <div className='main-title'>{props.title}</div>
        <div className='products-container'>
          {props.subTitle && <span className='sub-title'>{props.subTitle}</span>}
          {props.arr.map((p) => (
            <div className='product-container'>
              {p.title && <span className='sub-title'>{p.title}</span>}
              <div className='full-price'>
                <span className='name'>{p.name}</span>
                <span className='price'>{p.price === 0 ? 'ללא עלות' : '₪' + p.price}</span>
              </div>
              {p.monthly && (
                <span className='monthly-price' dir='rtl'>
                  <span>{p.payments}</span>
                  <span>X</span>
                  <span>₪{p.monthlyPrice}</span>
                  <span>לחודש</span>
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }
  function TotalPrice(props) {
    return (
      <div className='total-price-container'>
        <span>{props.title}</span>
        <span>₪{props.totalPrice}</span>
      </div>
    );
  }
  function getTotalPrice(Arr) {
    let totalPrice = 0;
    Arr.forEach((element) => {
      const priceToInt = parseFloat(element.price);
      totalPrice += priceToInt;
    });
    return totalPrice;
  }

  function createDom() {
    return (store.isSaleDone && isEsimAndLineType && store.processType != 'DEVICE') ? (
      <>
        <SuccessEsim EsimData={props.contentData.esimContentData} LineType={isEsimAndLineType.type} {...props}></SuccessEsim>

      </>
    ) : (
      <>
        {isSubmitSuccess == false ? (
          <ErrorPage errorCode={store.errorReason} />
        ) : (
          <div className='main-container step' dir='rtl' ref={captureRef}>
            <div className='order-summary-container'>
              {!store.isSaleDone ? (
                <>
                  <div className='title-container'>
                    <span className='main-title'>סיכום פרטי ההזמנה</span>
                    <span className='sub-title'>האם כל הפרטים נכונים?</span>
                  </div>
                  <div className='divider'></div>
                </>
              ) : isSubmitSuccess != true && !isEsimAndLineType ? (
                <></>
              ) : (
                <>
                  <div className='title-container'>
                    <span className='main-title'>איזה כיף שהצטרפת אלינו!</span>
                    {store.deliveryMode === 'DELIVERY' && (
                      <>
                        <span className='sub-title'>
                          {' '}
                          נפגש ב{deliveryInfo.deliveryHebrewDayOfTheWeek}, {deliveryInfo?.deliveryDate} בין {deliveryInfo?.deliveryRange[0]}
                          -{deliveryInfo?.deliveryRange[1]}
                        </span>
                      </>
                    )}
                  </div>
                </>
              )}

              {(isEsim && esimText?.length > 0) &&
                <>
                  <div className='esim info-container'>
                    {esimTitle && <div className='info-title'>
                      <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <circle cx='12' cy='12' r='9.5' fill='#C5A0EF' stroke='var(--theme-primary, #810ea9)' />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M13.697 8.12c0-.938-.76-1.698-1.697-1.698a1.705 1.705 0 0 0-1.697 1.697 1.697 1.697 0 0 0 3.394 0zm.565 8.55a.486.486 0 0 1-.486.487h-3.554a.486.486 0 0 1-.486-.486v-.956c0-.269.218-.486.486-.486h.486v-2.582h-.486a.486.486 0 0 1-.486-.486v-.956c0-.269.218-.486.486-.486h2.574c.269 0 .486.217.486.486v4.032h.486c.269 0 .486.217.486.486l.008.948z'
                          fill='var(--theme-primary, #810ea9)'
                        />
                      </svg>
                      <span>{esimTitle}</span>
                    </div>}
                    <div className='info-text'>
                      <ul>
                        {esimText?.map((text, index) => <li key={index}>{text}</li>)}
                      </ul>
                    </div>
                  </div>
                  <div className='divider'></div>
                </>
              }

              <div className='subscriber-no-container'>
                <span className='field-title'>מנוי {getCustomerNewNumber()} </span>
              </div>

              <div className='divider'></div>
              <PriceInformation title={'חיוב בגין ציוד'} subTitle={'מוצרים'} arr={productsArr}></PriceInformation>

              {store.processType === 'DEVICE' && (
                <TotalPrice title={'סה״כ חיוב בגין ציוד'} totalPrice={getTotalPrice(productsArr)}></TotalPrice>
              )}
              <div className='divider'></div>
              <PriceInformation title={'חיובים חודשיים'} subTitle={''} arr={monthlyProductsArr}></PriceInformation>
              <TotalPrice title={'סה״כ חיוב חודשי'} totalPrice={getTotalPrice(monthlyProductsArr)}></TotalPrice>
              <div className='divider'></div>

              <PriceSummarySection title='פרטי אמצעי תשלום' />
              <div className='info'>
                <span>סוג כרטיס: {GetCreditCardTypeId(paymentInfo?.cardType)}</span>
                <span>מספר כרטיס: {paymentInfo?.last4Digits}</span>
                <span>תוקף: {paymentInfo?.expirationDate}</span>
                <span>מספר ת.ז: {paymentInfo?.id}</span>
              </div>

              {/* Delivery info */}
              {((store.deliveryMode === 'DELIVERY' || store.deliveryMode === 'PICKUP') &&
                <>
                  <div className='divider'></div>
                  <PriceSummarySection title='קבלת הזמנה' />
                  {store.deliveryMode === 'DELIVERY' ? (
                    <div className='info'>
                      <span className='detail'>
                        השליח יגיע ב{deliveryInfo.deliveryHebrewDayOfTheWeek}, {deliveryInfo?.deliveryDate} בין{' '}
                        {deliveryInfo?.deliveryRange[0]}-{deliveryInfo?.deliveryRange[1]}
                      </span>
                      <span className='detail'>לכתובת {deliveryInfo?.address}</span>
                      {!store.isSimInMailBox && (
                        <span className='detail'>
                          יקבל את השליח {deliveryInfo?.recipientName} {deliveryInfo.recipientPhoneNumber}
                        </span>
                      )}
                      {store.deliveryComments != "" && <span className='detail'> הערות לשליח : {store.deliveryComments}</span>}

                    </div>
                  ) : (
                    <div className='info'>
                      <span className='detail'>{store?.pickupServiceCenter?.service_center_name}</span>
                      <span className='detail'>{store.pickupServiceCenter?.service_center_location}</span>
                      <span className='detail'>{formatActivityHours(store.pickupServiceCenter?.activity_hours)}</span>
                    </div>
                  )}
                </>
              )}
              {!store.isSaleDone ? (
                <>
                  {' '}
                  <div className='divider'></div>
                  <span className='field-title'> דוא"ל אליו ישלח סיכום פרטי ההזמנה </span>
                  <div className='info'>
                    <span className='detail'>{store.selectedEmail}</span>
                  </div>
                  {isEsim && (<>
                    <span className='field-title'>
                      <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path
                          d='M14.119 12.533c-.27.15-.416.448-.416.747v1.302l-4.158.341V13.28a.883.883 0 0 0-.375-.747c-1.434-.854-2.1-2.134-2.1-3.885-.02-2.625 2.038-4.76 4.554-4.76 2.516 0 4.574 2.135 4.574 4.76-.02 1.708-.77 3.16-2.08 3.885z'
                          fill='#E0C1FF'
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M5.39 8.643c0-3.564 2.828-6.467 6.238-6.467 3.41 0 6.238 2.903 6.259 6.467 0 2.156-1.04 4.034-2.495 5.122v1.601c0 .449-.375.811-.811.854l-5.718.47H8.78a.842.842 0 0 1-.582-.235c-.167-.15-.312-.384-.312-.62v-2.09C6.222 12.57 5.39 10.82 5.39 8.642zm8.317 4.63c0-.298.145-.597.415-.746 1.31-.726 2.059-2.177 2.08-3.885 0-2.625-2.059-4.76-4.575-4.76-2.515 0-4.574 2.135-4.553 4.76 0 1.75.665 3.031 2.1 3.885.25.17.374.448.374.747v1.643l4.159-.341v-1.302z'
                          fill='var(--theme-primary, #810ea9)'
                        />
                        <path
                          d='m14.519 18.955-5.676.427H8.78c-.436 0-.79-.342-.831-.79a.851.851 0 0 1 .769-.918l5.676-.426a.82.82 0 0 1 .894.79.851.851 0 0 1-.77.917zM12.708 21.644l-2.037.17h-.063c-.436 0-.79-.34-.831-.789a.851.851 0 0 1 .77-.918l2.057-.17a.827.827 0 0 1 .874.79.851.851 0 0 1-.77.917zM14.934 8.622c-.042.385-.354.683-.728.683h-.062a.737.737 0 0 1-.645-.81c.125-1.217-.915-1.666-1.04-1.708a.776.776 0 0 1-.436-.96c.125-.385.54-.598.915-.449.769.278 2.183 1.323 1.996 3.244z'
                          fill='var(--theme-primary, #810ea9)'
                        />
                      </svg> <>  מספר הטלפון אליו יישלחו הנחיות להפעלת ה-Esim</> </span>

                    <div className='info'>
                      <span className='detail'>{store.userDetails.otp_phone}</span>
                    </div>
                  </>
                  )}

                  <Buttons onClickNavigation={onSubmit} canContinue={true} />
                </>
              ) : (
                <>
                  <div className='divider'></div>
                  <PriceSummarySection title='סיכום ההזמנה נשלח לדוא"ל' />
                  <div className='info'>
                    <span className=''>{store.selectedEmail}</span>
                  </div>
                  <div className='orderSummaryBtn'>
                    <div className='action-btns-container'>
                      <BtnWhiteBlackBorderSmallSize text='שמירה כתמונה' onclick={capturePage} />
                      {store.deliveryMode === 'DELIVERY' && (
                        <BtnWhiteBlackBorderSmallSize text='הוספת תזכורת ליומן' onclick={handleAddToCalenderClick} />
                      )}
                    </div>
                  </div>
                </>
              )}
              {store.isSaleDone && <OrderSummarySucceededButton />}
            </div>
          </div>
        )}
      </>
    );
  }

  return createDom()
};

export default OrderSummary;
